import React, { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";
import Content from "./Content";
import { useSummary } from "./hooks";

function HomePage() {
  const { keycloak } = useKeycloak();
  const { summary, isLoading, isError } = useSummary();
  console.log(summary, isLoading, isError);
  if (isLoading) return null;
  return (
    // Your page content
    <div>
      <Content userCount={summary?.rip_count || 0}></Content>
    </div>
  );
}

export default HomePage;
